// extracted by mini-css-extract-plugin
module.exports = {"rounded-corners":"Sermons_rounded-corners__24r_k"};